import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-airplane-depart icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_3 = { class: "base-model__content" };
var _hoisted_4 = { class: "base-model__header" };
var _hoisted_5 = { class: "base-model__header-title heading-h5" };
var _hoisted_6 = ["onClick"];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-close icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_8 = [
    _hoisted_7
];
var _hoisted_9 = { class: "mobile-booking-tabs" };
var _hoisted_10 = { class: "base-model__body" };
var _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
var _hoisted_12 = { class: "booking-widget-mobile__after-sales" };
import useMatchMedia from '../../hooks/useMatchMedia';
import BaseModal from '../BaseModal/BaseModal.vue';
import BookingWidget from './BookingWidget.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingWidgetMobile',
    props: {
        isAlwaysShown: { type: Boolean },
        dataContentId: {},
        promoCodeProp: {},
        prefillTripType: {},
        prefillCabinClass: {},
        prefillFromDate: {},
        prefillToDate: {},
        prefillOrigin: {},
        prefillDestination: {}
    },
    setup: function (__props) {
        var isNotMobile = useMatchMedia('(min-width: 744px)');
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_unref(isNotMobile) || _ctx.isAlwaysShown)
                    ? (_openBlock(), _createBlock(BaseModal, {
                        key: 0,
                        "action-required": ""
                    }, {
                        trigger: _withCtx(function (_a) {
                            var openModal = _a.openModal;
                            return [
                                _createElementVNode("button", {
                                    role: "button",
                                    "aria-label": "Optional description of what happens when the link is clicked",
                                    class: "button button--lg button--iconright button--text-left button--highlighted-action hover-shadow",
                                    onClick: function (e) { openModal(e); }
                                }, [
                                    _renderSlot(_ctx.$slots, "book-trip-text"),
                                    _hoisted_2
                                ], 8 /* PROPS */, _hoisted_1)
                            ];
                        }),
                        "modal-content": _withCtx(function (_a) {
                            var closeModal = _a.closeModal;
                            return [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("p", _hoisted_5, [
                                            _renderSlot(_ctx.$slots, "book-trip-text")
                                        ]),
                                        _createElementVNode("button", {
                                            role: "button",
                                            "aria-label": "Dismiss modal",
                                            class: "button--text button--icon base-model__header-close",
                                            onClick: function () { closeModal(); }
                                        }, _hoisted_8, 8 /* PROPS */, _hoisted_6)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _renderSlot(_ctx.$slots, "tabs")
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(BookingWidget, {
                                            "data-content-id": _ctx.dataContentId,
                                            "promo-code-prop": _ctx.promoCodeProp,
                                            "prefill-origin": _ctx.prefillOrigin,
                                            "prefill-destination": _ctx.prefillDestination,
                                            "prefill-trip-type": _ctx.prefillTripType,
                                            "prefill-cabin-class": _ctx.prefillCabinClass,
                                            "prefill-from-date": _ctx.prefillFromDate,
                                            "prefill-to-date": _ctx.prefillToDate
                                        }, {
                                            "visa-modal": _withCtx(function (_a) {
                                                var itineraries = _a.itineraries;
                                                return [
                                                    _renderSlot(_ctx.$slots, "visa-modal", { itineraries: itineraries })
                                                ];
                                            }),
                                            terms: _withCtx(function () { return [
                                                _renderSlot(_ctx.$slots, "terms")
                                            ]; }),
                                            _: 3 /* FORWARDED */
                                        }, 8 /* PROPS */, ["data-content-id", "promo-code-prop", "prefill-origin", "prefill-destination", "prefill-trip-type", "prefill-cabin-class", "prefill-from-date", "prefill-to-date"]),
                                        _hoisted_11,
                                        _createElementVNode("div", _hoisted_12, [
                                            _renderSlot(_ctx.$slots, "after-sales")
                                        ])
                                    ])
                                ])
                            ];
                        }),
                        _: 3 /* FORWARDED */
                    }))
                    : _createCommentVNode("v-if", true),
                _renderSlot(_ctx.$slots, "after-sales")
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
